<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><span><img alt="2010-11-08T18-23-50-706_9781550924589_0004_001" class="imgpub" id="d14e65" src="Images/2010-11-08T18-23-50-706_9781550924589_0004_001.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c2_r1.vue?0041d164